import { useEffect } from "react";

export default function useDisableBodyScroll(disable) {
  useEffect(() => {
    const body = document.body;

    if (disable) {
      body.setAttribute('data-scroll-locked', 'true');
    } else {
      body.removeAttribute('data-scroll-locked');
    }

    return () => {
      body.removeAttribute('data-scroll-locked');
    };
  }, [disable]);

  return null;
}
